import { render, staticRenderFns } from "./EditorSideControls.vue?vue&type=template&id=bbb47408&"
import script from "./EditorSideControls.vue?vue&type=script&lang=ts&"
export * from "./EditorSideControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports